import { render, staticRenderFns } from "./fireMonitor.vue?vue&type=template&id=2edbc55a&scoped=true&"
import script from "./fireMonitor.vue?vue&type=script&lang=js&"
export * from "./fireMonitor.vue?vue&type=script&lang=js&"
import style0 from "./fireMonitor.vue?vue&type=style&index=0&id=2edbc55a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbc55a",
  null
  
)

export default component.exports